import { useErrorContext } from "../../global/hooks/useErrorContext";
import { IPlanComment } from "../types/interfaces/IPlanComment";
import { IlpData } from "../types/classes/IlpData";

//This custom hook is responsible for making a POST request to the save a comment to a learning plan end point.
export default function useSaveComment(apiEndPoint: string): ((requestBody: IlpData<string>) => Promise<IPlanComment | null>) {
    const { setError } = useErrorContext();

    const INELIGIBLE_ERROR_TEXT: string | null = process.env.REACT_APP_ILP_INELIGIBLE_ERROR_TEXT ?? null;

    const handleError = (message: string | null, statusCode: number) => {  
        setError({ message, statusCode });
        return null;
    };

    const saveCommentFetch = async (requestBody: IlpData<string>): Promise<IPlanComment | null> => {
        try {
            const response = await fetch(apiEndPoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody)
            });
            if (!response.ok) {
                console.log('useSaveComment', response.statusText);
                if (response.status === 401 || response.status === 403) {
                    return handleError(INELIGIBLE_ERROR_TEXT, -response.status);
                } else {
                    return handleError(null, -41);
                }
            }
            const result = await response.json();
            if (!result) {
                return handleError(null, -42);
            } else {
                if (result.Data === null || (!result.Succeeded && result.Errors !== null)) {
                    return handleError(null, -43);
                }
            }
            return result.Data;
        } catch (error: any) {
            console.log('useSaveComment error', error);
            return handleError(null, -error.status);
        }
    };

    return async (requestBody: IlpData<string>) => {
        return saveCommentFetch(requestBody);
    };
}